import { FC } from 'react'

import { Checkbox as MantineCheckbox, CheckboxProps } from '@mantine/core'
import styled from 'styled-components'

import { colors } from 'src/Helpers/constants.ts'

export type CheckboxInnerProps = CheckboxProps

const StyledCheckbox = styled(MantineCheckbox)`
  div {
    display: flex !important;
    flex-direction: row !important;
    gap: 10px !important;
  }

  .mantine-Checkbox-labelWrapper {
    white-space: nowrap;
  }

  .mantine-Checkbox-label {
    padding: 0 !important;
  }

  .mantine-Checkbox-inner {
    width: unset;
  }

  .mantine-Checkbox-input:checked {
    background-color: ${colors.fourthBlue};
    border-color: ${colors.fourthBlue};
  }

  label {
    color: ${colors.thirdGray};
  }
`

export const Checkbox: FC<CheckboxInnerProps> = (props) => {
  return <StyledCheckbox {...props} />
}
